import Vue from "vue";
import Router from "vue-router";
import { setPageTitle } from "./common/utils";

Vue.use(Router);

// const appraisalIntroduction = () =>
//   import(
//     /* webpackChunkName: 'appraisal-introduction' */ "@/views/appraisal-introduction/new-index"
//   );
const staticPage = () =>
  import(/* webpackChunkName: 'static-page' */ "@/views/static-page");
// const orderFlow = () =>
//   import(/* webpackChunkName: 'order-flow' */ "@/views/order-flow");
const offlineIdentityOrderFlow = () =>
  import(
    /* webpackChunkName: 'offline-order-flow' */ "@/views/offline-identify-order-flow"
  );
const consignRecycleOrderFlow = () =>
  import(
    /* webpackChunkName: 'consign-recycle-order-flow' */ "@/views/consign-recycle-order-flow"
  );
const productNews = () =>
  import(/* webpackChunkName: 'product-news' */ "@/views/product-news");
const serviceProviderAccess = () =>
  import(
    /* webpackChunkName: 'service-provider-access' */ "@/views/service-provider-access"
  );
const appWechatBridge = () =>
  import(
    /* webpackChunkName: 'app-wechat-bridge' */ "@/views/app/wechat-bridge"
  );
const openApp = () =>
  import(
    /* webpackChunkName: 'open-app' */ "@/views/open-app"
  );
// const publicAccountQrcode = () =>
//   import(
//     /* webpackChunkName: 'public-account-qrcode' */ "@/views/public-account-qrcode"
//   );
const login = () => import(/* webpackChunkName: 'login' */ "@/views/login");
// 钱包
const walletIndex = () =>
  import(/* webpackChunkName: 'wallet-index' */ "@/views/wallet");
const walletMain = () =>
  import(/* webpackChunkName: 'wallet-main' */ "@/views/wallet/main");
const walletRunningCount = () =>
  import(
    /* webpackChunkName: 'wallet-running-count' */ "@/views/wallet/running-count"
  );
const walletBindAlipay = () =>
  import(
    /* webpackChunkName: 'wallet-bind-alipay' */ "@/views/wallet/bind-alipay"
  );
const walletWithdraw = () =>
  import(/* webpackChunkName: 'wallet-withdraw' */ "@/views/wallet/withdraw");
const bindAlipaySuccess = () =>
  import(
    /* webpackChunkName: 'wallet-bind-success' */ "@/views/wallet/bind-success"
  );
const withdrawSuccess = () =>
  import(
    /* webpackChunkName: 'wallet-withdraw-success' */ "@/views/wallet/withdraw-success"
  );

// 抽奖小工具 数字滚动
// const lotteryDrawIndex = () =>
//   import(/* webpackChunkName: 'lottery-draw' */ "@/views/lottery-draw");
// const lotteryDraw = () =>
//   import(
//     /* webpackChunkName: 'lottery-draw-main' */ "@/views/lottery-draw/main"
//   );
// const prizeList = () =>
//   import(
//     /* webpackChunkName: 'prize-list' */ "@/views/lottery-draw/prize-list"
//   );
// const historyLottery = () =>
//   import(
//     /* webpackChunkName: 'history-lottery' */ "@/views/lottery-draw/history-lottery"
//   );

// AI识图结果页面
const aiPictureIndex = () =>
  import(/* webpackChunkName: 'picture-index' */ "@/views/ai-picture");
const aiPictureMain = () =>
  import(/* webpackChunkName: 'picture-main' */ "@/views/ai-picture/main");
const aiPictureMainStock = () =>
  import(
    /* webpackChunkName: 'picture-stock' */ "@/views/ai-picture/main-stock"
  );
const aiPicturePre = () =>
  import(/* webpackChunkName: 'picture-pre' */ "@/views/ai-picture/pre");
const aiPictureSimilar = () =>
  import(
    /* webpackChunkName: 'picture-similar' */ "@/views/ai-picture/similar"
  );
const aiPictureOnSale = () =>
  import(/* webpackChunkName: 'picture-on-sale' */ "@/views/ai-picture/onsale");
const aiPictureTrade = () =>
  import(/* webpackChunkName: 'picture-trade' */ "@/views/ai-picture/trade");
const aiPictureNomatch = () =>
  import(
    /* webpackChunkName: 'picture-no-match' */ "@/views/ai-picture/no-match"
  );
// 手镯识别demo
const braceLet = () =>
  import(/* webpackChunkName bracelet */ "@/views/brancelet");

// 品牌馆 热款行情
// const hotDetail = () =>
//   import(/* webpackChunkName hotDetail */ "@/views/hot-detail");
// // 以旧换新
// const tradeIn = () => import(/* webpackChunkName tradeIn */ "@/views/trade-in");
// const tradeInUseRule = () =>
//   import(/* webpackChunkName tradeInUseRule */ "@/views/trade-in/use-rule");

// 联系客服
const wechatConsult = () =>
  import(/* webpackChunkName wechatConsult */ "@/views/wechat-consult");

// 车辆定损
const carPicture = () =>
  import(/* webpackChunkName wechatConsult */ "@/views/car-picture");

// 鉴别报告
const appraisalReport = () =>
  import(/* webpackChunkName appraisalReport */ "@/views/appraisal-report");
const appraisalReportWood = () =>
  import(/* webpackChunkName appraisalReport */ "@/views/appraisal-report/wood");
const appraisalResult = () =>
  import(/* webpackChunkName appraisalResult */ "@/views/appraisal-result");
const ccicReport = () =>
  import(/* webpackChunkName appraisalResult */ "@/views/ccic-report");
const zpwReport = () =>
  import(
    /* webpackChunkName appraisalResult */ "@/views/open-reports/zpw-report"
  );
const aiReport = () =>
  import(
    /* webpackChunkName appraisalResult */ "@/views/open-reports/ai-report"
  );
const aiReportTusee = () =>
  import(
    /* webpackChunkName appraisalResult */ "@/views/open-reports/ai-report-tusee"
);
const zpReport = () =>
  import(/* webpackChunkName appraisalResult */ "@/views/open-reports/wp");
const jingdongReport = () =>
  import(/* webpackChunkName appraisalResult */ "@/views/appraisal-report/jingdong");

const zrReport = () =>
  import(/* webpackChunkName appraisalResult */ "@/views/appraisal-report/zr");

const zrsyReport = () =>
  import(/* webpackChunkName appraisalResult */ "@/views/appraisal-report/zrsy");

const zrsy2Report = () =>
  import(/* webpackChunkName appraisalResult */ "@/views/appraisal-report/zrsy2");

const aliintlReport = () =>
  import(/* webpackChunkName appraisalResult */ "@/views/appraisal-report/aliintl");
const gpyReport = () =>
  import(/* webpackChunkName appraisalResult */ "@/views/appraisal-report/gpy");

// 查询云仓购买、出售物流信息
const sellBuyOrderFlow = () =>
  import(/* webpackChunkName wechatConsult */ "@/views/sell-buy-order-flow");
const bagBusiness = () =>
  import(/* webpackChunkName wechatConsult */ "@/views/bag-show/business");
const bagProductList = () =>
  import(/* webpackChunkName wechatConsult */ "@/views/bag-show/product-list");
const bagProductDetail = () =>
  import(
    /* webpackChunkName wechatConsult */ "@/views/bag-show/product-detail"
  );
const qrcodePage = () =>
  import(
    /* webpackChunkName wechatConsult */ "@/views/bag-show/product-detail/code"
  );
const payPage = () =>
  import(/* webpackChunkName wechatConsult */ "@/views/bag-show/pay-page");

// 查询云仓采购相关页面
const purchaseMerchant = () =>
  import(/* webpackChunkName wechatConsult */ "@/views/purchase/merchant");
const purchasePayPage = () =>
  import(/* webpackChunkName wechatConsult */ "@/views/purchase/pay-page");
const purchaseProductDetail = () =>
  import(
    /* webpackChunkName wechatConsult */ "@/views/purchase/product-detail"
  );
const purchaseProductList = () =>
  import(/* webpackChunkName wechatConsult */ "@/views/purchase/product-list");
const purchaseCartList = () =>
  import(/* webpackChunkName wechatConsult */ "@/views/purchase/cart-list");
const companyInfo = () =>
  import(
    /* webpackChunkName wechatConsult */ "@/views/purchase/pay-page/company-info"
  );
const purchaseQrcodePage = () =>
  import(
    /* webpackChunkName wechatConsult */ "@/views/purchase/product-detail/code"
  );

// 查询云仓采购测试相关页面
const purchaseMerchantTest = () =>
  import(/* webpackChunkName wechatConsult */ "@/views/purchase-test/merchant");
const purchasePayPageTest = () =>
  import(/* webpackChunkName wechatConsult */ "@/views/purchase-test/pay-page");
const purchaseProductDetailTest = () =>
  import(
    /* webpackChunkName wechatConsult */ "@/views/purchase-test/product-detail"
  );
const purchaseProductListTest = () =>
  import(
    /* webpackChunkName wechatConsult */ "@/views/purchase-test/product-list"
  );
const purchaseCartListTest = () =>
  import(
    /* webpackChunkName wechatConsult */ "@/views/purchase-test/cart-list"
  );
const companyInfoTest = () =>
  import(
    /* webpackChunkName wechatConsult */ "@/views/purchase-test/pay-page/company-info"
  );
const purchaseQrcodePageTest = () =>
  import(
    /* webpackChunkName wechatConsult */ "@/views/purchase-test/product-detail/code"
  );
const openReportsWood = () =>
  import(
    /* webpackChunkName wechatConsult */ "@/views/open-reports/wood"
  );

// 支付功能
const PayPage = () =>
  import(/* webpackChunkName wechatConsult */ "@/views/pay");
const WxPayPage = () =>
  import(/* webpackChunkName wechatConsult */ "@/views/pay/wxpay");
const LieWuPayPage = () =>
  import(/* webpackChunkName wechatConsult */ "@/views/pay/liewu-pay");

const psDemo = () =>
  import(/* webpackChunkName wechatConsult */ "@/views/ps-demo");
const PS = () => import(/* webpackChunkName wechatConsult */ "@/views/ps");
const vehicle = () => import(/* webpackChunkName wechatConsult */ "@/views/vehicle");
const psSelect = () => import(/* webpackChunkName wechatConsult */ "@/views/ps-select");
const psStage = () => import(/* webpackChunkName wechatConsult */ "@/views/ps-stage");
const cardDetail = () => import(/* webpackChunkName wechatConsult */ "@/views/card-detail");
const cardReport = () => import(/* webpackChunkName wechatConsult */ "@/views/card-report");
const tuseeUserDeacative = () => import(/* webpackChunkName wechatConsult */ "@/views/tusee/deacative");
const identifyTakePhoto = () =>
  import(/* webpackChunkName: 'identify-take-photo' */ "@/views/identify-take-photo");

//外包鉴定师鉴定-字节二期需求
const appraiserLoginPage = () => import("@/views/appraiser/login");
const orderDetailPage = () => import("@/views/appraiser/orderDetail");
const cantAppriseToManualOrderDetailPage = () => import("@/views/appraiser/cantAppriseToManualOrderDetail");

//外包鉴定师复核系列
const orderDetailReviewPage = () => import("@/views/review-series/orderDetail");
const reviewLogin = () => import("@/views/review-series/review-login");

const router = new Router({
  // mode: 'history',
  base: "/",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    // {
    //   path: "/appraisal-introduction",
    //   name: "appraisal-introduction",
    //   meta: {
    //     title: "包小鉴鉴别介绍",
    //   },
    //   component: appraisalIntroduction,
    // },
    {
      path: "/static-page/:name",
      name: "staticPage",
      meta: {
        title: "",
      },
      component: staticPage,
    },
    // {
    //   path: "/order-flow",
    //   name: "orderFlow",
    //   meta: {
    //     title: "物流动态",
    //   },
    //   component: orderFlow,
    // },
    {
      path: "/offline-identify-order-flow",
      name: "offLineOrderFlow",
      meta: {
        title: "查看进度",
      },
      component: offlineIdentityOrderFlow,
    },
    {
      path: "/consign-recycle-order-flow",
      name: "consignRecycleOrderFlow",
      meta: {
        title: "查看进度",
      },
      component: consignRecycleOrderFlow,
    },
    // {
    //   path: "/public-account-qrcode",
    //   name: "public-account-qrcode",
    //   meta: {
    //     title: "包小鉴公众号",
    //   },
    //   component: publicAccountQrcode,
    // },
    {
      path: "/product-news",
      name: "productNews",
      meta: {
        title: "成色说明",
      },
      component: productNews,
    },
    {
      path: "/service-provider-access",
      name: "serviceProviderAccess",
      meta: {
        title: "服务商接入",
      },
      component: serviceProviderAccess,
    },
    {
      path: "/app/wechat-bridge",
      name: "appWechatBridge",
      component: appWechatBridge,
      meta: {
        title: "包小鉴微信小程序",
      },
    },
    {
      path: "/lanuch-esteelauder/:id",
      name: "openApp",
      component: openApp,
      meta: {
        title: "打开应用",
      },
    },
    {
      path: "/wallet",
      name: "wallet",
      component: walletIndex,
      meta: {
        title: "钱包",
      },
      children: [
        {
          path: "",
          name: "walletMain",
          component: walletMain,
          meta: {
            title: "钱包",
          },
        },
        {
          path: "running-count",
          name: "walletRunningCount",
          component: walletRunningCount,
          meta: {
            title: "收支明细",
          },
        },
        {
          path: "bind-alipay",
          name: "walletBindAlipay",
          component: walletBindAlipay,
          meta: {
            title: "收支明细",
          },
        },
        {
          path: "withdraw",
          name: "walletWithdraw",
          component: walletWithdraw,
          meta: {
            title: "提现",
          },
        },
        {
          path: "bindAlipay-success",
          name: "bindAlipaySuccess",
          component: bindAlipaySuccess,
          meta: {
            title: "绑定成功",
          },
        },
        {
          path: "withdraw-success",
          name: "withdrawSuccess",
          component: withdrawSuccess,
          meta: {
            title: "提现成功",
          },
        },
      ],
    },
    {
      path: "/login",
      name: "login",
      meta: {
        title: "H5登录",
      },
      component: login,
    },
    // 抽奖
    // {
    //   path: "/lottery-draw",
    //   name: "lotteryDraw",
    //   component: lotteryDrawIndex,
    //   meta: {
    //     title: "抽奖",
    //   },
    //   children: [
    //     {
    //       // 抽奖小工具
    //       path: "",
    //       name: "lotteryDraw",
    //       component: lotteryDraw,
    //       meta: {
    //         title: "抽奖小工具",
    //       },
    //     },
    //     // 历史抽奖 - 活动 - 点击进入中奖名单
    //     {
    //       path: "history-lottery",
    //       name: "historyLottery",
    //       component: historyLottery,
    //       meta: {
    //         title: "历史抽奖",
    //       },
    //     },
    //     {
    //       path: "prize-list",
    //       name: "prizeList",
    //       component: prizeList,
    //       meta: {
    //         title: "中奖名单",
    //       },
    //     },
    //   ],
    // },
    // ai识图
    {
      path: "/ai-picture",
      name: "aiPicture",
      component: aiPictureIndex,
      meta: {
        title: "行情百科",
      },
      children: [
        {
          path: "/",
          name: "aiPictureMain",
          component: aiPictureMain,
          keepAlive: true,
          meta: {
            title: "行情百科",
          },
        },
        {
          path: "stock-picture",
          name: "aiPictureMainStock",
          component: aiPictureMainStock,
          keepAlive: true,
          meta: {
            title: "包小鉴商品标准信息",
          },
        },
        {
          path: "pre",
          name: "pre",
          component: aiPicturePre,
          keepAlive: false,
          meta: {
            title: "行情百科",
          },
        },
        {
          path: "similar-design",
          name: "similarDesign",
          component: aiPictureSimilar,
          keepAlive: true,

          meta: {
            title: "相似款式",
          },
        },
        {
          path: "on-sale",
          name: "onSale",
          component: aiPictureOnSale,
          keepAlive: true,

          meta: {
            title: "在售",
          },
        },
        {
          path: "trade-record",
          name: "tradeRecord",
          component: aiPictureTrade,
          keepAlive: true,

          meta: {
            title: "交易记录",
          },
        },
        {
          path: "no-match",
          name: "noMatch",
          component: aiPictureNomatch,
          keepAlive: true,

          meta: {
            title: "AI识包",
          },
        },
      ],
    },
    // 翡小鉴
    {
      path: "/bracelet",
      name: "bracelet",
      component: braceLet,
      meta: {
        title: "翡小鉴",
      },
    },
    // 品牌馆 热款行情
    // {
    //   path: "/hot-detail",
    //   name: "hot-detail",
    //   component: hotDetail,
    //   meta: {
    //     title: "热款行情",
    //   },
    // },
    // 以旧换新
    // {
    //   path: "/trade-in",
    //   name: "trade-in",
    //   component: tradeIn,
    //   meta: {
    //     title: "以旧换新",
    //   },
    // },
    // // 以旧换新 使用细则
    // {
    //   path: "/trade-in-use-rule",
    //   name: "trade-in-use-rule",
    //   component: tradeInUseRule,
    //   meta: {
    //     title: "个人信息收集使用规则",
    //   },
    // },
    {
      path: "/wechat-consult",
      name: "wechatConnect",
      meta: {
        title: "联系客服",
      },
      component: wechatConsult,
    },
    // 车辆定损demo
    {
      path: "/car-picture",
      name: "carPicture",
      component: carPicture,
      meta: {
        title: "车损识别Demo",
      },
    },
    // 购买售卖物流页
    {
      path: "/sell-buy-order-flow",
      name: "sellBuyOrderFlow",
      component: sellBuyOrderFlow,
      meta: {
        title: "物流动态",
      },
    },
    // 商家展位列表
    {
      path: "/bag-show/business",
      name: "bagBusinessList",
      component: bagBusiness,
      meta: {
        title: "商家展位",
      },
    },
    // 商品信息列表
    {
      path: "/bag-show/product-list/:businessId",
      name: "bagProductList",
      component: bagProductList,
      meta: {
        title: "商品列表",
      },
    },
    // 商品详情
    {
      path: "/bag-show/product-detail/:pid",
      name: "bagProductDetail",
      component: bagProductDetail,
      meta: {
        title: "商品详情",
      },
    },
    // 商品二维码页面
    {
      path: "/bag-show/qrcode/:pid",
      name: "qrcodePage",
      component: qrcodePage,
      meta: {
        title: "商品二维码",
      },
    },
    // 商品二维码页面
    {
      path: "/bag-show/pay-page",
      name: "payPage",
      component: payPage,
      meta: {
        title: "订单支付",
      },
    },
    // 鉴别报告页面 双路由兼容页面
    {
      path: "/appraisal-report/:ai/:sequence",
      name: "appraisalReport",
      component: appraisalReport,
      meta: {
        title: "鉴别报告",
      },
    },
    // 鉴别报告页面
    {
      path: "/appraisal-report/:sequence",
      name: "appraisalReport",
      component: appraisalReport,
      meta: {
        title: "鉴别报告",
      },
    },
    {
      path: "/appraisal-report-demo/wood",
      name: "appraisalReportWood",
      component: appraisalReportWood,
      meta: {
        title: "鉴别报告",
      },
    },
    {
      path: "/appraisal-result/:orderId",
      name: "appraisalResult",
      component: appraisalResult,
      meta: {
        title: "鉴别结果",
      },
    },
    {
      path: "/ccic-report/:appraisalno",
      name: "ccicReport",
      component: ccicReport,
      meta: {
        title: "图灵鉴定x中检在线鉴别报告",
      },
    },
    // 采购相关功能
    // 采购商功能页面
    {
      path: "/purchase/merchant",
      name: "merchant",
      component: purchaseMerchant,
      meta: {
        title: "供应商列表",
      },
    },
    {
      path: "/purchase/product-list/:uid",
      name: "productList",
      component: purchaseProductList,
      meta: {
        title: "商品信息列表",
      },
    },
    {
      path: "/purchase/product-detail/:pid",
      name: "productDetail",
      component: purchaseProductDetail,
      meta: {
        title: "商品详情",
      },
    },
    {
      path: "/purchase/pay-page",
      name: "payPage",
      component: purchasePayPage,
      meta: {
        title: "订单支付",
      },
    },
    {
      path: "/purchase/cart-list",
      name: "cartList",
      component: purchaseCartList,
      meta: {
        title: "购物车",
      },
    },
    {
      path: "/purchase/company-info",
      name: "companyInfo",
      component: companyInfo,
      meta: {
        title: "确认转账汇款",
      },
    },
    {
      path: "/purchase/qrcode/:pid",
      name: "purchaseQrcodePage",
      component: purchaseQrcodePage,
      meta: {
        title: "商品二维码",
      },
    },

    // 采购相关功能测试
    // 采购商功能页面
    {
      path: "/purchase-test/merchant",
      name: "merchantTest",
      component: purchaseMerchantTest,
      meta: {
        title: "供应商列表",
      },
    },
    {
      path: "/purchase-test/product-list/:uid",
      name: "productListTest",
      component: purchaseProductListTest,
      meta: {
        title: "商品信息列表",
      },
    },
    {
      path: "/purchase-test/product-detail/:pid",
      name: "productDetailTest",
      component: purchaseProductDetailTest,
      meta: {
        title: "商品详情",
      },
    },
    {
      path: "/purchase-test/pay-page",
      name: "payPageTest",
      component: purchasePayPageTest,
      meta: {
        title: "订单支付",
      },
    },
    {
      path: "/purchase-test/cart-list",
      name: "cartListTest",
      component: purchaseCartListTest,
      meta: {
        title: "购物车",
      },
    },
    {
      path: "/purchase-test/company-info",
      name: "companyInfoTest",
      component: companyInfoTest,
      meta: {
        title: "确认转账汇款",
      },
    },
    {
      path: "/purchase-test/qrcode/:pid",
      name: "purchaseQrcodePageTest",
      component: purchaseQrcodePageTest,
      meta: {
        title: "商品二维码",
      },
    },
    {
      path: "/pay",
      name: "pay",
      component: PayPage,
      meta: {
        title: "收银台",
      },
    },
    {
      path: "/wxpay",
      name: "wxpay",
      component: WxPayPage,
      meta: {
        title: "微信支付",
      },
    },
    {
      path: "/liewu-pay",
      name: "liewuPay",
      component: LieWuPayPage,
      meta: {
        title: "裂物支付",
      },
    },
    // 外包鉴定师鉴定
    {
      path: "/appraiser/login/:moaid",
      name: "appraiserLogin",
      component: appraiserLoginPage,
      meta: {
        title: "鉴定师登录",
      },
    },
    {
      path: "/appraiser/orderDetail",
      name: "orderDetail",
      component: orderDetailPage,
      meta: {
        title: "订单详情",
      },
    },
    // 无法转人工详情
    {
      path: "/appraiser/cantAppriseToManualOrderDetail",
      name: "cantAppriseToManualOrderDetail",
      component: cantAppriseToManualOrderDetailPage,
      meta: {
        title: "订单详情",
      },
    },
    // 复核系列
    {
      path: "/review-series/orderDetail/:moaid",
      name: "reviewSeriesDetail",
      component: orderDetailReviewPage,
      meta: {
        title: "订单详情",
      },
    },
    {
      path: "/review-series/review-login",
      name: "reviewLogin",
      component: reviewLogin,
      meta: {
        title: "鉴定师登录",
      },
    },
    {
      path: "/wp-report/:appraisalno",
      name: "zpReport",
      component: zpReport,
      meta: {
        title: "鉴别报告",
      },
    },
    {
      path: "/zr/:code",
      name: "zr",
      component: zrReport,
      meta: {
        title: "中认鉴别报告",
      },
    },
    {
      path: "/zrsy/:code",
      name: "zrsy",
      component: zrsyReport,
      meta: {
        title: "中认溯源鉴别报告",
      },
    },
    {
      // 中认溯源 V2 新版报告页。与 /zrsy/:code 并存、互不影响：
      // 走哪条由挂签渠道在发码时决定（aiservice 按渠道拼 URL），老码永远指向 /zrsy/
      path: "/zrsy2/:code",
      name: "zrsy2",
      component: zrsy2Report,
      meta: {
        title: "溯源报告",
      },
    },
    {
      path: "/aliintl/:code",
      name: "aliintl",
      component: aliintlReport,
      meta: {
        title: "Inspection Report",
      },
    },
    {
      path: "/gpy",
      name: "gpy",
      component: gpyReport,
      meta: {
        title: "高拍仪鉴别报告",
      },
    },
    {
      path: "/jd/:code",
      name: "jd",
      component: jingdongReport,
      meta: {
        title: "鉴别报告",
      },
    },
    {
      path: "/zpw-report/:appraisalno",
      name: "zpwReport",
      component: zpwReport,
      meta: {
        title: "鉴别报告",
      },
    },
    {
      path: "/ai-report/:appraisalno",
      name: "aiReport",
      component: aiReport,
      meta: {
        title: "鉴别报告",
      },
    },
    {
      path: "/ai-report-tusee/:appraisalno",
      name: "aiReportTusee",
      component: aiReportTusee,
      meta: {
        title: "鉴别报告",
      },
    },
    {
      path: "/identify/take-photo",
      name: "identifyTakePhoto",
      component: identifyTakePhoto,
      meta: {
        title: "鉴别图片拍摄",
      },
    },
    {
      path: "/appraisal/ps",
      name: "ps",
      component: PS,
      meta: {
        title: "防篡改黑科技",
      },
    },
    {
      path: "/appraisal/ps/select",
      name: "psSelect",
      component: psSelect,
      meta: {
        title: "选择证件类型",
      },
    },
    {
      path: "/appraisal/ps/stage",
      name: "psStage",
      component: psStage,
      meta: {
        title: "上传图片",
      },
    },
    {
      path: "/appraisal/vehicle",
      name: "vehicle",
      component: vehicle,
      meta: {
        title: "车损",
      },
    },
    {
      path: "/appraisal/card-detail",
      name: "card-detail",
      component: cardDetail,
      meta: {
        title: "卡牌详情",
      },
    },
    {
      path: "/tsa",
      name: "card-report",
      component: cardReport,
      meta: {
        title: "评级报告",
      },
    },
    {
      path: "/ai-report/wood/:id",
      name: "report-wood",
      component: openReportsWood,
      meta: {
        title: "木作鉴定报告",
      },
    },
    {
      path: "/tusee/deacative",
      name: "deacative",
      component: tuseeUserDeacative,
      meta: {
        title: "User deacative",
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  /* 修改页面标题 */
  if (to.meta && to.meta.title) {
    setPageTitle(to.meta.title);
  }
  next();
});

export default router;
